import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-details-contenue',
    templateUrl: './details-contenue.component.html',
    styleUrls: ['./details-contenue.component.scss']
})
export class DetailsContenueComponent implements OnInit {
    reference: string | null = null;

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.reference = params.get('reference');
            if (this.reference && this.router.url === `/tiers/clients/details/${this.reference}`) {
                this.router.navigate([`/tiers/clients/details/${this.reference}/detail-contenue-apercue`], {
                    replaceUrl: true
                });
            }
        });
    }
}
